import type { ReactNode } from "react";
import correctBadge from "../../../../../../../assets/static/images/inbox/avatar-inner__correct.png";
import incorrectBadge from "../../../../../../../assets/static/images/inbox/avatar-inner__incorrect.png";
import giftBadge from "../../../../../../../assets/static/images/inbox/avatar-inner__gift.png";
import genericBadge from "../../../../../../../assets/static/images/inbox/avatar-inner__generic.png";
import "./InboxMessageCard.scss";

export type InboxMessageVariant = "correct" | "incorrect" | "gift" | "generic";

const BADGES: Record<InboxMessageVariant, string> = {
    correct: correctBadge,
    incorrect: incorrectBadge,
    gift: giftBadge,
    generic: genericBadge,
};

interface InboxMessageCardProps {
    title: string;
    body: string;
    variant?: InboxMessageVariant;
    createdAt: string;
    ageLabel: string;
    countdown?: string;
    countdownLabel?: string;
    rewardAction?: ReactNode;
    children?: ReactNode;
    isRead?: boolean;
}

/** Shared presentation; eligibility, copy and reward values belong to the caller. */
export function InboxMessageCard({
    title,
    body,
    variant = "generic",
    createdAt,
    ageLabel,
    countdown,
    countdownLabel,
    rewardAction,
    children,
    isRead = false,
}: InboxMessageCardProps) {
    const badge = BADGES[variant];

    return (
        <article
            className="inbox-message-card"
            data-variant={variant}
            data-read={String(isRead)}
        >
            <div className="inbox-message-card__face">
                <span className="inbox-message-card__badge" aria-hidden="true">
                    {badge && <img src={badge} alt="" draggable={false} />}
                </span>
                <div className="inbox-message-card__content">
                    <div className="inbox-message-card__metadata">
                        <time dateTime={createdAt}>{ageLabel}</time>
                        {countdown && (
                            <>
                                <span aria-hidden="true">·</span>
                                <span dir="ltr" aria-label={countdownLabel}>
                                    {countdown}
                                </span>
                            </>
                        )}
                    </div>
                    <h3 className="inbox-message-card__title">{title}</h3>
                    <div className="inbox-message-card__divider" />
                    <div className="inbox-message-card__bottom">
                        <p className="inbox-message-card__body">{body}</p>
                        {rewardAction && (
                            <div className="inbox-message-card__action">
                                {rewardAction}
                            </div>
                        )}
                    </div>
                    {children}
                </div>
            </div>
        </article>
    );
}
